import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import { selectLoggedIn } from "../store/slices/auth/slice";
import { selectUserInfo } from "../store/slices/user/slice";

const PrivateLayout = () => {
  const loggedIn = useSelector(selectLoggedIn);
  const { verified } = useSelector(selectUserInfo);

  if (!loggedIn) {
    return <Navigate to="/" state={{}} replace />;
  }

  if (!verified) {
    return <Navigate to="/verify-email" state={{}} replace />;
  }

  return <Outlet />;
};

export default PrivateLayout;
